/** Settle both success and failure while ignoring an obsolete view's response. */
export function loadIntegrationList(requestFactory, {isActive, onResult, onError, onSettled}) {
    return Promise.resolve().then(requestFactory).then((result) => {
        if (isActive()) onResult(result);
    }).catch((error) => {
        if (isActive()) onError(error);
    }).finally(() => {
        if (isActive()) onSettled();
    });
}
